import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
export const DoubleArrowUpIcon = () => (_jsx("div", { css: css `
      transform: rotate(-90deg);
    `, children: _jsx(DoubleArrowRoundedIcon, {}) }));
